import { createAction } from '@reduxjs/toolkit';

export const TRANSFER_QUEUED_ACTION_TYPE = 'saga/transferQueued';
export const transferQueuedAction = createAction(TRANSFER_QUEUED_ACTION_TYPE);
